import api from '@/services/api/admin/userDataElement.js'
import { immerable } from "immer"
import { useState } from 'react'

class UserDataElement {

	[immerable] = true

	constructor(params) {
		this.dataElementId = params.dataElementId
		this.userId = params.userId
	}
}

function serialize(entry) {
	return {
		dataElementId: entry.dataElementId,
		userId: entry.userId
	}
}


const useUserDataElement = () => {
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ?? "";

		const [errorResponse, data] = await api.index({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError('User Data Elements API has error')
		}

		if (!Array.isArray(data)) {
			return setError('User Data Elements is not an array')
		}

		const serializedData = data.map(entry => serialize(entry))
		const newItems = serializedData.map(entry => new UserDataElement(entry))

		return setItems(newItems)
	}

	return {
		items,
		loading,
		error,
		fetch
	}
}

export default useUserDataElement
